import React, { useEffect, useState } from "react";
import {
  FormStyle,
  FormSubElementStyle,
  PageDescriptionLoginMobileStyle,
} from "../../login/components/RightSideContainer";
import { SectionTitle } from "../../login/components/SectionTitle";
import { Button } from "../../../components/Button";
import { EKYC_VERIFY_OTP_TEXT } from "./constant";
import OtpVerifyAction from "../../../actions/ekyc/login/verifyOtp";
import OtpSentAction from "../../../actions/ekyc/login/otpSent";
import useStore from "../../../appZustand/store";
import styled from "styled-components";
import CommonInput from "../../login/componentLoginScreen/CommonInput";
import { useHistory } from "react-router-dom";
import ROUTES, { EKYC } from "../../../helpers/constants/routes";
import getUserInfo from "../../../actions/getUserInfo";
import JSEncrypt from "node-jsencrypt";
import { is_encrypt, PUBLIC_RSA_KEY } from "../../../app-config";
import { MobileTextBox } from "../../../components/MobileTextBox";
import {
  sslContainer,
  sslTitle,
  logoImage,
  textContainer,
  titleSSL,
  titleDataSecurity,
  titleDataSecurity1,
} from "../../../theme/commonStyles.js";

const LinkText = styled.span`
  font-weight: 500;
  font-size: 16px;
  line-height: 140%;
  text-decoration-line: underline;
  color: #3e96c8;
  cursor: pointer;
`;

const Text = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  color: #3e96c8;
  cursor: pointer;
`;

const VerifyOtp = () => {
  const { mobileNo } = useStore((state) => state);
  const history = useHistory();
  const mobileView = history.location.state.mobileView;
  const isForgotPassword = history.location.state.isForgotPassword;

  const [data, setData] = useState({
    otp: null,
    isError: false,
    errorObj: {},
    isLoading: false,
    resendCountdown: "",
    isForgotPassword: false,
  });

  const onChangeAction = (e) => {
    const { name, value } = e.target;
    const cleanValue = value.replace(/\D/g, "");
    if (cleanValue.length > 6) {
      return false;
    }
    setData({ ...data, [name]: cleanValue });
  };

  useEffect(() => {
    let { resendCountdown } = data;

    const timer =
      resendCountdown &&
      setInterval(
        () => setData({ ...data, resendCountdown: resendCountdown - 1 }),
        1000,
      );

    return () => clearInterval(timer);
  }, [data]);

  const triggerOTP = () => {
    OtpSentAction({
      login_username: mobileNo,
      method_of_login: "phone_otp",
      purpose: "user_login",
    }).then((res) => {
      setData({ ...data, isLoading: false, resendCountdown: 30 });
      console.log(res);
    });
  };

  const encrypt_password = (string_to_encrypt) => {
    if (is_encrypt) {
      let encrypt = new JSEncrypt();
      encrypt.setPublicKey(PUBLIC_RSA_KEY);
      return encrypt.encrypt(string_to_encrypt);
    } else {
      return string_to_encrypt;
    }
  };

  const verifyAction = () => {
    setData({ ...data, isLoading: true });
    OtpVerifyAction({
      login_username: mobileNo,
      method_of_login: "phone_otp",
      password: encrypt_password(data.otp),
      platform: "my_track",
    })
      .then((res) => {
        console.log("kjdsjkdskjdskhjsdhjf",res)
        if (isForgotPassword) {
          history.push(EKYC.SET_ACCOUNT_PASSWORD, {
            mobileView: data.mobileView,
            name: res?.user_data?.name,
            phone: res?.user_data?.phone_number,
            token: res?.sessionid,
          });
        } else {
          setData({ ...data, isLoading: false });
          localStorage.setItem("sessionid", res.sessionid);
          localStorage.setItem("userName", res.username);
          localStorage.setItem("reload", "reload");
          history.push(EKYC.DASHBOARD);
        }
      })
      .catch((err) => {
        setData({
          ...data,
          isLoading: false,
          isError: true,
          errorObj: { ...err },
        });
      });
  };

  const backHandler = () => {
    history.push(EKYC.LOGIN);
  };

  return mobileView ? (
    <>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "90%",
          maxWidth: "440px",
          padding: "2.5rem 1.5rem",
          marginTop: "-30px",
          backgroundColor: "#ffffff",
          borderRadius: "16px",
          boxShadow: "0 10px 25px rgba(0, 0, 0, 0.05)",
          zIndex: 2,
        }}
      >
        <h3 style={{ fontSize: 18, fontWeight: "600", color: "#333", marginBottom: "8px" }}>Verify OTP</h3>
        <p style={{ padding: 0, margin: "0 0 15px 0", fontSize: 14, color: "#666", textAlign: "center" }}>
          Enter the OTP sent to {mobileNo}
        </p>
        <FormStyle style={{ width: "100%" }}>
          <MobileTextBox
            labelName="OTP"
            name={"otp"}
            type="tel"
            // check="ekycInput"
            value={data.otp || ""}
            onChange={onChangeAction}
            error={data.isError}
            errorMessage={data.errorObj?.code || data.errorObj?.detail}
            subElement={
              <FormSubElementStyle onClick={triggerOTP}>
                <LinkText
                  style={{
                    cursor: data.resendCountdown ? "not-allowed" : "pointer",
                  }}
                >
                  {`Resend ${data.resendCountdown ? `${data.resendCountdown}'s` : ""}`}
                </LinkText>
              </FormSubElementStyle>
            }
          />
          <Button
            type="submit"
            onClick={verifyAction}
            isLoading={data.isLoading}
            width="100%"
            bgColor="#4770C1"
            borderRadius="8px"
            fontStyle={{ fontSize: "14px", marginTop: "35px" }}
            boxHeight="38px"
          >
            Verify OTP
          </Button>
          <div style={{ display: "flex", justifyContent: "center", marginTop: "20px" }}>
            <Text onClick={backHandler} style={{ textDecoration: "underline", color: "#4770C1", fontWeight: "500" }}>Go back to login screen</Text>
          </div>
        </FormStyle>
      </div>

      <div style={{ ...sslContainer, marginTop: "20px", width: "90%", maxWidth: "440px" }}>
        <div style={sslTitle}>
          <img src="/favicons/lock.png" alt="SSL Lock Logo" style={logoImage} />
          <div style={textContainer}>
            <p style={titleSSL}>SSL</p>
            <p style={titleDataSecurity}>ENCRYPTION</p>
          </div>
        </div>

        <p style={titleDataSecurity1}>100% DATA SECURITY</p>
      </div>
    </>
  ) : (
    <form className="login-Form" onSubmit={(e) => { e.preventDefault(); verifyAction(); }}>
      <h2 className="login-heading" style={{ marginBottom: 20 }}>
        Verify OTP
      </h2>
      <p style={{ color: "#777", marginBottom: 30, fontSize: "16px", fontFamily: "barlow" }}>
        Enter the OTP sent to {mobileNo}
      </p>

      <CommonInput
        type="text"
        inputMode="numeric"
        label="OTP"
        name="otp"
        value={data.otp || ""}
        onChange={onChangeAction}
        error={data.isError ? (data.errorObj?.code || data.errorObj?.detail || "") : ""}
        autoFocus
      />

      <div
        style={{
          width: "70%",
          display: "flex",
          justifyContent: "space-between",
          marginTop: "45px",
          alignItems: "center",
        }}
      >
        <button
          className="next-button"
          type="submit"
          disabled={data.isLoading}
        >
          Verify OTP
        </button>

        <span
          onClick={triggerOTP}
          style={{
            fontSize: "16px",
            color: "#4770C1",
            textDecoration: "underline",
            cursor: data.resendCountdown ? "not-allowed" : "pointer",
            fontWeight: "500",
            fontFamily: "barlow",
          }}
        >
          {`Resend ${data.resendCountdown ? `${data.resendCountdown}s` : ""}`}
        </span>
      </div>

      <div style={{ marginTop: "20px" }}>
        <span
          onClick={backHandler}
          style={{
            fontSize: "14px",
            color: "#4770C1",
            cursor: "pointer",
            fontFamily: "barlow",
            textDecoration: "underline",
          }}
        >
          Go back to login screen
        </span>
      </div>
    </form>
  );
};

export default VerifyOtp;
